module.exports = __webpack_public_path__ + "static/image7-0b5272e1466f20dd1ab4f5f33ac5152e.jpg";